import React from 'react'
import Box from '@material-ui/core/Box'
import SyncAltOutlinedIcon from 'components/material-symbol/icons/SyncAlt'
import AddOutlinedIcon from 'components/material-symbol/icons/Add'
import SectionEmptyState from 'components/section-empty-state'
import { TonalButton } from 'components/empty-page-state'
import { useStyles } from './styles'
import NewSponsorshipModal from './new-sponsorship-modal'

const NoSponsorships = ({ facilities, refetch }) => {
  const styles = useStyles()

  return (
    <Box className={styles.containerStyles}>
      <Box className={styles.listEmptyStateContent}>
        <SectionEmptyState
          Icon={SyncAltOutlinedIcon}
          title="Sponsorships"
          caption="You do not have any PGA Coach sponsorships. Add a new sponsorship to allow a non-PGA of America member at your facility to use the PGA Coach platform. Please note this is not access to other PGA of America programming."
          bordered={false}
          action={
            <NewSponsorshipModal
              trigger={
                <TonalButton startIcon={<AddOutlinedIcon />}>
                  New Sponsorship
                </TonalButton>
              }
              onAdd={() => {
                refetch()
              }}
              facilities={facilities}
            />
          }
        />
      </Box>
    </Box>
  )
}

export default NoSponsorships
